(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _excluded = ["isOpen", "onClose", "title", "children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  title: _propTypes.node,
  isOpen: _propTypes.bool.isRequired,
  onClose: _propTypes.func.isRequired,
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func])
};

var Modal = function Modal(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      title = props.title,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var modalContainer = (0, _react.useMemo)(function () {
    var container = document.createElement("div");
    container.setAttribute("class", "modal-container grower-portal");
    document.querySelector("#content").appendChild(container);
    return container;
  }, []);
  var overflowRef = (0, _react.useRef)(); // keep around the children so when we close, we can fade out with the content

  var childrenCache = (0, _react.useRef)(); // if children is a funciton, render it with some state

  var content = typeof children === "function" ? children({
    isOpen: isOpen,
    title: title
  }) : children;

  if (content) {
    childrenCache.current = content;
  } // listen for esc if the modal is open


  (0, _react.useEffect)(function () {
    var keydownHandler = function keydownHandler(e) {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      // always open with the modal scrolled to the top
      if (overflowRef.current) {
        overflowRef.current.scrollTo(0, 0);
      }

      window.addEventListener("keydown", keydownHandler);
      return function () {
        return window.removeEventListener("keydown", keydownHandler);
      };
    } else {
      window.removeEventListener("keydown", keydownHandler);
    }
  }, [isOpen, onClose]);
  (0, _react.useEffect)(function () {
    // document.querySelector("body").classList.toggle("modal-open", isOpen); can't use this because of IE11
    var classList = document.querySelector("body").classList;

    if (isOpen) {
      classList.add("modal-open");
    } else {
      classList.remove("modal-open");
    }
  }, [isOpen]);
  var classes = (0, _classnames.default)("modal", className, {
    "is-open": isOpen
  });

  var modalNode = /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes,
    role: "dialog",
    ref: overflowRef
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__box-holder"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__overlay",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_reactFocusLock.default, {
    disabled: !isOpen,
    returnFocus: true,
    className: "modal__box",
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__title"
  }, title, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "modal__close",
    onClick: onClose,
    "aria-label": "close"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    className: "octicon octicon-x",
    viewBox: "0 0 12 16",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__content"
  }, childrenCache.current))));

  return /*#__PURE__*/_reactDom.default.createPortal(modalNode, modalContainer);
};

Modal.propTypes = propTypes;
var _default = Modal;
exports.default = _default;

},{"classnames":"classnames","prop-types":"prop-types","react":"react","react-dom":"react-dom","react-focus-lock":"react-focus-lock"}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Modal = _interopRequireDefault(require("../Modal/Modal.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  modalTitle: _propTypes.string.isRequired,
  modalDescription: _propTypes.string.isRequired,
  shouldDisplayModal: _propTypes.bool.isRequired,
  cookieName: _propTypes.string.isRequired
};

var ScheduledModal = function ScheduledModal(props) {
  var modalTitle = props.modalTitle,
      modalDescription = props.modalDescription,
      shouldDisplayModal = props.shouldDisplayModal,
      cookieName = props.cookieName;
  var notAgainCookie = Cookies.get(cookieName + "_dontShow");

  var _useState = (0, _react.useState)(shouldDisplayModal && !notAgainCookie),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dontShowAgain = _useState4[0],
      setDontShowAgain = _useState4[1];

  var handleClick = function handleClick() {
    return setDontShowAgain(!dontShowAgain);
  };

  var handleClose = function handleClose() {
    if (dontShowAgain) {
      setCookie(cookieName + "_dontShow", "true", 5);
    }

    setIsOpen(false);
  };

  function setCookie(name, value, days) {
    var date, expires;
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    isOpen: isOpen,
    onClose: handleClose,
    className: "modal--scheduled-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal--scheduled-modal__title",
    dangerouslySetInnerHTML: {
      __html: modalTitle
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal--scheduled-modal__description",
    dangerouslySetInnerHTML: {
      __html: modalDescription
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal--scheduled-modal__footer"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleClose,
    type: "button",
    className: "modal--scheduled-modal__btn"
  }, "OK")), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal--scheduled-modal__not-again"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    onClick: handleClick,
    defaultChecked: dontShowAgain,
    type: "checkbox"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox__custom"
  }), /*#__PURE__*/_react.default.createElement("div", null, "Don't show this again")))));
};

ScheduledModal.propTypes = propTypes;
var _default = ScheduledModal;
exports.default = _default;

},{"../Modal/Modal.jsx":1,"prop-types":"prop-types","react":"react"}],3:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var R = _interopRequireWildcard(require("ramda"));

var _ScheduledModal = _interopRequireDefault(require("../components/ScheduledModal/ScheduledModal.jsx"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener("DOMContentLoaded", function () {
  var mountClass = ".js-scheduled-modal-mount";
  var mountNode = document.querySelector(mountClass);

  if (!mountNode) {
    console.error("".concat(mountClass, " element not found!"));
    return;
  }

  var data = R.compose(JSON.parse, function (node) {
    return node.getAttribute("data-model");
  })(mountNode);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ScheduledModal.default, data), mountNode);
});

},{"../components/ScheduledModal/ScheduledModal.jsx":2,"ramda":"ramda","react":"react","react-dom":"react-dom"}]},{},[3]);
